import React from 'react';
import type { SVGProps } from 'react';
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 19"
    {...props}
  >
    <path
      fill={props?.fill || 'rgb(172, 185, 201)'}
      d="M6.103 5.052v2.034h3.173l-.448 3.207H6.069V18.5h-3.31v-8.207H0V7.086h2.759V4.741C2.759 2.017 4.449.5 6.862.5c1.172 0 2.172.103 2.483.138V3.5h-1.69c-1.31 0-1.552.62-1.552 1.552"
    />
  </svg>
);
export default SvgFacebook;
